import React, { useState } from 'react';
import './turnover-invoice-item-tab.scss';
import { ReactComponent as ArrowRightIcon } from '@zonofi/svg-icons/arrow_right.svg';
import { ReactComponent as CloseIcon } from '@zonofi/svg-icons/cross-icon.svg';
import { ReactComponent as SearchIcon } from '@zonofi/svg-icons/search-icon.svg';
import { ChipFilters, SearchComponent } from '@zonofi/seller-hub/components';
import { ChipFilterSection } from '@zonofi/seller-hub/types';
import {
  InvoiceItem,
  InvoiceItemCard,
} from '../invoice-item-card/invoice-item-card';

type FilterKey = 'all' | 'mapped' | 'unmapped';

export interface TurnoverInvoiceItemTabProps {
  items: InvoiceItem[];
}

export const TurnoverInvoiceItemTab: React.FC<TurnoverInvoiceItemTabProps> = ({
  items,
}) => {
  const [activeFilter, setActiveFilter] = useState<FilterKey>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showSearch, setShowSearch] = useState(false);

  const search: SearchComponent = {
    searchInput: {
      state: { showSearch, showSearchWindow: false },
      component: showSearch && (
        <div className="tiit-search-wrap">
          <SearchIcon height={16} width={16} color="#8C8C8C" />
          <input
            className="tiit-search-input font-regular"
            placeholder="Search items..."
            value={searchQuery}
            autoFocus
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            className="tiit-search-close"
            onClick={() => {
              searchQuery.length > 0
                ? setSearchQuery('')
                : setShowSearch(false);
            }}
          >
            <CloseIcon height={14} width={14} />
          </button>
        </div>
      ),
    },
    searchResult: {
      state: { showSearchWindow: false },
      component: null,
    },
  };

  const chipSections: ChipFilterSection[] = [
    {
      items: [
        { id: 'all', value: 'All', selected: activeFilter === 'all' },
        { id: 'mapped', value: 'Mapped', selected: activeFilter === 'mapped' },
        {
          id: 'unmapped',
          value: 'Unmapped',
          selected: activeFilter === 'unmapped',
        },
      ],
      onItemPress: (item) => setActiveFilter(item.id as FilterKey),
    },
  ];

  const filteredItems = items.filter((item) => {
    const matchesFilter =
      activeFilter === 'all' ||
      (activeFilter === 'mapped' && item.status === 'mapped') ||
      (activeFilter === 'unmapped' &&
        (item.status === 'unmapped' || item.status === 'brand_not_found'));

    const q = searchQuery.toLowerCase();
    const matchesSearch =
      !q ||
      item.name.toLowerCase().includes(q) ||
      item.sku.includes(q) ||
      item.hsn.includes(q);

    return matchesFilter && matchesSearch;
  });

  return (
    <div className="tiit-root">
      <ChipFilters
        sections={chipSections}
        search={search}
        showSearch={showSearch}
        chipFilterStyles={{ padding: '10px 16px' }}
        startElement={
          !showSearch ? (
            <button
              className="tiit-search-toggle"
              onClick={() => setShowSearch(true)}
            >
              <SearchIcon height={18} width={18} color="#1a2340" />
            </button>
          ) : null
        }
      />

      <div className="tiit-scroll-content">
        <div className="tiit-items-list">
          {filteredItems.length === 0 ? (
            <div className="tiit-empty font-regular">No items found.</div>
          ) : (
            filteredItems.map((item) => (
              <InvoiceItemCard key={item.id} item={item} />
            ))
          )}
        </div>
      </div>

      <div className="tov-actions">
        <button className="tov-btn tov-btn--reject font-semibold">
          Reject <CloseIcon height={16} width={16} color="#fff" />
        </button>
        <button className="tov-btn tov-btn--accept font-semibold">
          Accept <ArrowRightIcon height={16} width={16} color="#fff" />
        </button>
      </div>
    </div>
  );
};
